import './nav.css'
import '../App.css'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faGem, faFaceGrin, faGear, faWallet, faBoxOpen, faBarcode } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { handleVibration } from '../Pages/common/function';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation();
    let haptic = useSelector((state) => { return state.haptic.value })

    const [btn, setBtn] = useState(0)
    let location = useLocation()
    let navigate = useNavigate()

    useEffect(() => {
        if (location?.pathname == "/") setBtn(0)
        else if (location?.pathname == "/character") setBtn(1)
        else if (location?.pathname == "/airdrop") setBtn(2)
        else if (location?.pathname == "/friends") setBtn(3)
        else if (location?.pathname == "/coupons") setBtn(4)
        else setBtn(5)
    }, [location])

    const onClickBtn = (e) => {
        if (haptic) handleVibration(1);
        navigate(e)
    }

    return (
        <div className='footer'>
            <div className='footer-box'>
                <div className={`footer-box-1 ${btn === 0 ? "active" : ""}`}
                    onClick={() => onClickBtn('/')}>
                    <FontAwesomeIcon icon={faGem} fontSize={24} color={btn === 0 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_0')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 1 ? "active" : ""}`}
                    onClick={() => onClickBtn('/character')}>
                    <FontAwesomeIcon icon={faFaceGrin} fontSize={24} color={btn === 1 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_1')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 2 ? "active" : ""}`}
                    onClick={() => onClickBtn('/airdrop')}>
                    <img src='/img/saycoin.png' style={{ width: "24px" }} />
                    <div>{t('footer_2')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 3 ? "active" : ""}`}
                    onClick={() => onClickBtn('/friends')}>
                    <FontAwesomeIcon icon={faUsers} fontSize={24} color={btn === 3 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_3')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 4 ? "active" : ""}`}
                    onClick={() => onClickBtn('/coupons')}>
                    <FontAwesomeIcon icon={faBarcode} fontSize={24} color={btn === 4 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_7')}</div>
                </div>
                <div className={`footer-box-1`}
                    onClick={() => window.location.href = 'https://miniapp.ttory.com/wallet'}>
                    <FontAwesomeIcon icon={faWallet} fontSize={24} color={"#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_5')}</div>
                </div>
            </div>
        </div>
    )
}

export default Footer;